import { BrowserModule } from "@angular/platform-browser";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { APP_INITIALIZER, ErrorHandler, NgModule } from "@angular/core";
import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";
import { HttpClientModule, HTTP_INTERCEPTORS, HttpClientXsrfModule, provideHttpClient } from "@angular/common/http";


import { TableModule } from "primeng/table";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { ConfirmationService, MessageService } from "primeng/api";
import { ExcelService } from "./main-shared/services/excel.service";
import { ConfirmDialogModule } from "primeng/confirmdialog";
import { DropdownModule } from "primeng/dropdown";
import { CoreModule } from "./core/core.module";
import { KeycloakAngularModule, KeycloakService } from "keycloak-angular";
import { initializeKeycloak } from "./initializeKeycloak";
import { JwtInterceptor } from "./core/interceptors/jwt.interceptor";
import { ListboxModule } from 'primeng/listbox';
import { ToastModule } from "primeng/toast";
import { CalendarModule } from "primeng/calendar";
import { BreadcrumbModule } from 'primeng/breadcrumb';


import { PermissionManagerService } from "./authmanager/permission-manager.service";
import { RoleModuleMappingService } from "./authmanager/RoleModuleMapping";
import { DialogModule } from "primeng/dialog";
import { MainSharedModule } from "./main-shared/main-shared.module";
import { DialogService, DynamicDialogModule } from "primeng/dynamicdialog";
import { DatePipe, DecimalPipe } from "@angular/common";
import { NgIdleKeepaliveModule } from "@ng-idle/keepalive";
import { AppServiceService } from "./app-service.service";
import { AuthGuard } from "./core/guards/auth.guard";
import { ChildGuardGuard } from "./core/guards/child-guard.guard";
import { AccessDeniedComponent } from './access-denied/access-denied.component';
import { DateAgoPipe } from "./main-shared/pipes/date-ago.pipe";
import { TelemetryConfigService } from "./telemetry-config.service";
import { TelemetryBootstrapService } from "./telemetry-bootstrap.service";
import { GlobalErrorHandler } from "./global-error-handler";

export function telemetryAppInitializer(cfg: TelemetryConfigService, boot: TelemetryBootstrapService) {
  return async () => {
    await cfg.load();
    boot.init();
  };
}

@NgModule({
  declarations: [
    AppComponent,
    AccessDeniedComponent,
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    DialogModule,
    TableModule,
    FormsModule,
    ReactiveFormsModule,
    ConfirmDialogModule,
    DropdownModule,
    CoreModule,
    ListboxModule,
    ToastModule,
    CalendarModule,
    BreadcrumbModule,
    MainSharedModule,
    HttpClientModule,
    KeycloakAngularModule,
    DynamicDialogModule,
    HttpClientXsrfModule.withOptions({
      cookieName: 'XSRF-TOKEN',
      headerName: 'X-CSRF-TOKEN',
    }),
    NgIdleKeepaliveModule.forRoot(),
  ],
  providers: [
    ExcelService,
    MessageService,
    ConfirmationService,
    DialogService,
    DatePipe,
    DateAgoPipe,
    DecimalPipe,
    RoleModuleMappingService,
    KeycloakService,
    {
      provide: APP_INITIALIZER,
      useFactory: initializeKeycloak,
      multi: true,
      deps: [KeycloakService],
    },
    { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
    AppServiceService,
    PermissionManagerService,
    AuthGuard,
    ChildGuardGuard,

    provideHttpClient(),
    TelemetryConfigService,
    TelemetryBootstrapService,
    {
      provide: APP_INITIALIZER,
      useFactory: telemetryAppInitializer,
      deps: [TelemetryConfigService, TelemetryBootstrapService],
      multi: true
    },
    { provide: ErrorHandler, useClass: GlobalErrorHandler }
  ],
  bootstrap: [AppComponent],

})
export class AppModule { }
